<zest-title-step *ngIf="states.loan.IsTenureChanged && counterOffer" [mainTitle]="'Recommended EMI Plan'"></zest-title-step>
<div class="card offer-card" *ngIf="states.loan.IsTenureChanged && counterOffer">
  <div class="content no-padding-top">
    <div class="row offer-row">
      <div class="col s12">
        <p class="offer-heading" [textContent]="'Hey ' + firstName + ', you\'re approved for ' + counterOffer.SuggestedNumberOfInstallments + '-months EMI plan instead of ' + counterOffer.SelectedNumberOfInstallments + '-months you selected earlier.'">
        </p>
      </div>
    </div>
    <div class="row offer-row emi-row">
      <div class="col s12">
        <div class="emi-box-row">
          <div class="currency emi-box cancelled-box">
            <div class="amount" [textContent]="(counterOffer.SelectedTotalInstallmentAmount | RupeeCurrencyPipe)"></div>
            <div class="months" [textContent]="counterOffer.SelectedNumberOfInstallments + ' months'"></div>
          </div>
          <div class="currency emi-box blue-box">
            <div class="amount" [textContent]="(counterOffer.SuggestedTotalInstallmentAmount | RupeeCurrencyPipe)"></div>
            <div class="months" [textContent]="counterOffer.SuggestedNumberOfInstallments + ' months'"></div>
          </div>
        </div>
      </div>
      <div class="col s12">
        <div class="center">
          <button [ladda]="processingApprove" class="btn waves-effect zest-btn-2 ladda-button offer-btn-margin" [class.processing]="processingApprove"
            [disabled]="processingApprove" (click)="proceed()" *ngIf="!processingReject">
            <span>PROCEED</span>
          </button>
          <p class="cancel-offer center" [ladda]="processingReject" *ngIf="!processingApprove">
            <span (click)="showModal()">CANCEL LOAN</span>
          </p>
        </div>
      </div>
    </div>
    <div class="row offer-row">
      <div class="col s12">
        <p class="offer-heading header-padding" [textContent]="'Remember, with ZestMoney you can pre-close your loan at any time without any additional charges.'">
        </p>
      </div>
    </div>
  </div>
</div>
<div id="backToMerchant" class="modal" materialize="modal" [materializeParams]="[{dismissible: false}]">
  <div class="modal-content text-left">
    <p [textContent]="'Are you sure you want to go cancel your loan application? This will take you back to ' + application.MerchantName"></p>
  </div>
  <div class="modal-footer text-right">
    <button type="button" (click)="cancel()" class="btn btn-flat modal-btn modal-action modal-close waves-effect" [textContent]="'Yes'"></button>
    <button type="button" (click)="closeModal()" class="btn zest-btn-2 modal-btn modal-action modal-close waves-effect" [textContent]="'No'"></button>
  </div>
</div>
<div class="card offer-card" *ngIf="states.loan.IsLoanAmountChanged && counterOffer">
  <div class="content no-padding-top">
    <div class="row offer-row">
      <div class="col s12 offer-headers text-center">
        <p>You applied for a loan of <span class="currency" [textContent]="(counterOffer.SelectedLoanAmount | RupeeCurrencyPipe)"></span> for {{counterOffer.SelectedNumberOfInstallments}} months EMI plan at
          <span class="currency" [textContent]="(counterOffer.SelectedTotalInstallmentAmount | RupeeCurrencyPipe) + '/mo'"></span>
          <span class="currency" *ngIf="counterOffer.SelectedDownPaymentAmount && counterOffer.SelectedDownPaymentAmount > 0" [textContent]="' with a downpayment of ' + (counterOffer.SelectedDownPaymentAmount | RupeeCurrencyPipe)"></span>
        </p>
        <h4>However you have been approved for</h4>
      </div>
    </div>
    <div class="row offer-row">
      <div class="col s12">
        <div class="app-details">
          <div class="row info">
            <div class="col s6 heading text-left">
              <span>Loan Amount</span>
            </div>
            <div class="col s6 amount text-right">
              <span class="currency" [textContent]="(counterOffer.SuggestedLoanAmount | RupeeCurrencyPipe)"></span>
            </div>
          </div>
          <div class="tenure-selection">
            <p class="amount-txt">For {{counterOffer.SuggestedNumberOfInstallments}} months EMI plan at <span class="currency text-bold" [textContent]="(counterOffer.SuggestedTotalInstallmentAmount | RupeeCurrencyPipe)"></span></p>
            <p class="label-txt" *ngIf="counterOffer.SuggestedDownPaymentAmount && counterOffer.SuggestedDownPaymentAmount > 0" >with a downpayment of</p>
            <p class="amount-txt" *ngIf="counterOffer.SuggestedDownPaymentAmount && counterOffer.SuggestedDownPaymentAmount > 0" ><span class="currency text-bold" [textContent]="(counterOffer.SuggestedDownPaymentAmount | RupeeCurrencyPipe)"></span></p>
          </div>
        </div>
      </div>
      <div class="col s12">
        <div class="center">
          <button [ladda]="processingApprove" class="btn waves-effect zest-btn-2 ladda-button offer-btn-margin" [class.processing]="processingApprove"
            [disabled]="processingApprove" (click)="proceed()" *ngIf="!processingReject">
            <span>CONTINUE</span>
          </button>
          <p class="cancel-offer center" [ladda]="processingReject" *ngIf="!processingApprove">
            <span (click)="showModal()">CANCEL</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</div>